import { ReactNode } from 'react';

export function Card({ children }: { children: ReactNode }) {
  return (
    <div className="bg-primary-blue-200/25 rounded-lg p-4 flex gap-2 justify-center items-center w-full md:w-1/3">
      {children}
    </div>
  );
}
